// 1:1 redirect map (Appendix D + migration inventory). Old path -> new path.
// NOTE: true HTTP 301s depend on platform config at launch; this map also drives
// prerendered meta-refresh pages + client-side redirects as the in-app layer.
export const redirects = {
  "/web-design": "/services/websites",
  "/digital-marketing-agency": "/services",
  "/paid-media": "/services/paid-ads",
  "/organic-media": "/services/seo",
  "/social-media": "/services/content",
  "/hosting": "/services/hosting-it-support",
  "/fractional-cmo": "/services/fractional-cmo",
  "/about-us": "/about",
  "/connect": "/contact",
  "/contact-us": "/contact",
  "/privacy-policy": "/privacy",
  "/web-accessibility": "/accessibility",
  "/free-marketing-plan": "/marketing-fit",
  "/free-consultation": "/contact",
  "/inquire-now": "/contact",
  "/our-guarantee": "/about",
  "/shop": "/pricing",
  "/blockchain-solutions": "/services/ai",
  "/website-design": "/services/websites",
  "/blockchain-marketing": "/2021/01/12/what-is-blockchain-marketing-a-comprehensive-guide",
  "/thankyou": "/contact",
  "/cart": "/pricing",
};
